/* global axios */
import ApiClient from './ApiClient';

class WhatsappGroupsAPI extends ApiClient {
  constructor() {
    super('whatsapp_groups', { accountScoped: true });
  }

  // dispara a sincronizacao com a Evolution (roda em background, ~37s)
  sync() {
    return axios.post(`${this.url}/sync`);
  }
}

export default new WhatsappGroupsAPI();
